import React, { useState, useContext, useMemo } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { motion, AnimatePresence } from 'framer-motion';
import '../css/pors/doc_process.css';
import { Button, Table, Form, InputGroup, Pagination } from 'react-bootstrap';
import { MdEdit, MdBlockFlipped, MdSendAndArchive, MdSearch, MdUnfoldMore, MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import { Editnl } from '../edit/editNl';
import { ReasonNl } from '../reason/reason_Nl';
import api from '../../api';
import { Dimcontext } from "../../context/pagecontext";
import { AuthContext } from '../../context/authContext';
import Swal from 'sweetalert2';
import { Datacontext } from "../../context/dataContext"

const HomeNl = () => {
  const { setDim } = useContext(Dimcontext);
  const { nls, fetchNl } = useContext(Datacontext)
  const { user } = useContext(AuthContext);

  const [docedit, set_docedit] = useState(false);
  const [docid, set_docid] = useState('');
  const [reason, set_reason] = useState(false);
  const [appno, set_appno] = useState('');

  // --- Pagination & Search States ---
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: 'application_no', direction: 'desc' });

  const showToast = (msg) => 
      toast.warn(msg, {
        position: "bottom-center",
        autoClose:3000,
        theme: "dark",
        transition: Zoom,
      });
  
    const showsToast = (msg) => 
      toast.success(msg, {
        position: "bottom-center",
        autoClose: 3000,
        theme: "dark",
        transition: Zoom,
       });
  
  const docs = useMemo(() => {
      if (!nls) return [];
      const processingDocs = nls.filter(d => d.docstatus === "processing");
  
      if (user?.role === "user") {
        return processingDocs.filter(d => 
          // FIXED: Safe array fallback prevents .includes() from crashing on undefined
          (d?.managed_By || []).map(name => name.toLowerCase()).includes(user.name.toLowerCase())
        );
      }
      return processingDocs;
    }, [nls, user]);

  // --- Optimized Filtering & Sorting ---
  const processedData = useMemo(() => {
    let filtered = docs.filter(doc => {
      const ownerName = doc.owner?.name || "";
      const searchStr = `${ownerName} ${doc.application_no} ${doc.register_office}`.toLowerCase();
      return searchStr.includes(searchTerm.toLowerCase());
    });

    if (sortConfig.key) {
      filtered.sort((a, b) => {
        let aValue, bValue;

        if (sortConfig.key === 'name') {
          aValue = a.owner?.name || "";
          bValue = b.owner?.name || "";
        } else if (sortConfig.key === 'status') {
          // Extract nested status string for sorting
          aValue = a.status?.status || "";
          bValue = b.status?.status || "";
        } else {
          aValue = a[sortConfig.key] || "";
          bValue = b[sortConfig.key] || "";
        }

        const strA = String(aValue).toLowerCase();
        const strB = String(bValue).toLowerCase();

        if (strA < strB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (strA > strB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }
    return filtered;
  }, [docs, searchTerm, sortConfig]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = processedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(processedData.length / rowsPerPage);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const handleAction = (type, id, app) => {
    set_docid(id);
    setDim(true);
    if (type === 'edit') set_docedit(true);
    if (type === 'reject') { set_reason(true); set_appno(app); }
  };

  const calculateProgress = (doc) => {
  if (!doc || typeof doc !== 'object') return 0;

  // Step 1: Application & Executive Details (5 Fields)
  const step1Fields = [
    !!doc.zone, // zoneId
    !!doc.register_office, // officeId
    Array.isArray(doc.managed_By) && doc.managed_By.length > 0, // users1 (Safeguarded array check)
    !!doc.refered_by, // ref
    !!doc.owner // owner
  ];

  // Step 2: Document Process
  // Safeguarded toLowerCase to prevent TypeError if status is null
  const isOnline = doc.status?.status?.toLowerCase?.() === 'online';

  let hasPrimaryDocDetails = false;
  
  if (isOnline) {
    // Online: Valid if nlno is 'no' OR ('yes' and has a number)
    hasPrimaryDocDetails = 
      doc.nlno?.values === 'no' || 
      (doc.nlno?.values === 'yes' && !!doc.nlno?.no);
  } else {
    // Offline: Requires nlno value, valid payment, and valid stamp paper
    const nlnoValid = !!doc.nlno?.values;
    const payValid = doc.payment?.values === 'no' || (doc.payment?.values === 'yes' && !!doc.payment?.val);
    const stampValid = doc.stamp_paper?.values === 'no' || (doc.stamp_paper?.values === 'yes' && !!doc.stamp_paper?.val);
    
    hasPrimaryDocDetails = nlnoValid && payValid && stampValid;
  }

  const step2Fields = [
    hasPrimaryDocDetails,
    !!doc.nl_received?.values,
    !!doc.nl_delivered?.values,
    !!doc.estimated_cost
  ];

  // Combine all fields and calculate
  const allFields = [...step1Fields, ...step2Fields];
  const completedCount = allFields.filter(Boolean).length;
  const totalCount = allFields.length; // Will always be 9 based on current arrays

  const percentage = Math.floor((completedCount / totalCount) * 100);
  
  // Return at least 10% to show UI progress, unless the doc object was completely empty
  return percentage === 0 ? 10 : percentage;
};

  const handlecomplete = async (id) => {
  // Find the specific document from your nls array
  const doc = nls.find(item => item.id === id);
  
  // Calculate progress based on the logic we defined
  const currentProgress = calculateProgress(doc);

  // Check if the progress is 100%
  if (currentProgress === 100) {
    try {
      const result = await Swal.fire({
        title: 'Finalize Application?',
        text: "This will move the Nagal record to the completed archive.",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#4a127e', // Matching your Nagal theme color
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Complete it!',
        customClass: {
          confirmButton: "my-confirm-btn"
        }
      });

      if (result.isConfirmed) {
        await api.patch(`/updateone_nl/${id}`, { 
          data1: { docstatus: "completed" } 
        });
        showsToast("Application marked as Completed!");
        fetchNl();
      }
    } catch (error) { 
      console.error(error); 
      toast.error("Failed to update status");
    }
  } else {
    // Show a detailed warning if progress is less than 100%
    Swal.fire({ 
      title: "INCOMPLETE", 
      html: `Current Progress: <b>${currentProgress}%</b><br/>Please complete all Application Details and Document Processes before finalizing.`, 
      icon: "warning", 
      confirmButtonColor: "#e7ac2d",
      customClass: {
        confirmButton: "my-confirm-btn"
      }
    });
  }
};

  const getBadgeColor = (name) => {
    const variants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info'];
    return variants[name.length % variants.length];
  };

  return (
    <div className="home-layout-wrapper p-0 p-md-4">
      <ToastContainer />

      <div className="main-glass-card shadow-sm">
        <div className="card-header-custom d-flex justify-content-between align-items-center p-4">
          <h4 className="m-0 fw-bold text-dark">Processing Nagal (CCA)</h4>
          <div className="d-flex gap-3">
            <InputGroup className="search-bar">
              <InputGroup.Text className="bg-white border-end-0">
                <MdSearch size={20} className="text-muted" />
              </InputGroup.Text>
              <Form.Control
                placeholder="Search name, app no..."
                className="border-start-0 ps-0"
                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
              />
            </InputGroup>
          </div>
        </div>

        <div className="table-side-scroll-container">
          <Table hover striped responsive className="imtable">
            <thead>
              <tr>
                <th className="sticky-col pin-no">NO.</th>
                <th className="sticky-col pin-name cursor-pointer" onClick={() => handleSort('name')}>
                  NAME <MdUnfoldMore />
                </th>
                <th className="cursor-pointer" onClick={() => handleSort('application_no')}>
                  APP NO <MdUnfoldMore />
                </th>
                <th className="cursor-pointer" onClick={() => handleSort('status')}>
                  TYPE <MdUnfoldMore />
                </th>
                <th className="cursor-pointer" onClick={() => handleSort('document_date')}>
                  DATE <MdUnfoldMore />
                </th>
                <th className="cursor-pointer" onClick={() => handleSort('register_office')}>
                  OFFICE <MdUnfoldMore />
                </th>
                <th>MANAGED BY</th>
                <th>PROCESS</th>
                <th className="text-center">ACTION</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.length > 0 ? currentRows.map((doc, index) => (
                <tr key={doc.id}>
                  <td className="sticky-col pin-no">{indexOfFirstRow + index + 1}</td>
                  <td className="sticky-col pin-name fw-semibold">{doc.owner?.name?.toUpperCase() || "N/A"}</td>
                  <td><span className="app-badge">{doc.application_no}</span></td>
                  <td>
                    <div className="d-flex justify-content-center">
                      <span 
                        className={`badge rounded-pill bg-${doc?.status?.status?.toLowerCase() === 'online' ? 'success' : 'secondary'}`} 
                        style={{ fontSize: '0.60rem', minWidth: '55px' }}
                      >
                        {doc?.status?.status?.toUpperCase() || "N/A"}
                      </span>
                    </div>
                  </td>
                  
                  {/* FIXED: Safe Date Parsing */}
                  <td>{doc.date ? new Date(doc.date.split("-").reverse().join("-")).toLocaleDateString("en-GB") : "N/A"}</td>
                  
                  <td>{doc.register_office?.toUpperCase() || "N/A"}</td>
                  <td>
                    <div className="d-flex flex-wrap gap-1 justify-content-center">
                      {/* FIXED: Array.isArray prevents mapping over strings/undefined */}
                      {Array.isArray(doc.managed_By) && doc.managed_By.map((manager, i) => (
                        <span key={i} className={`badge rounded-pill bg-${getBadgeColor(manager)}`} style={{ fontSize: '0.60rem' }}>
                          {manager?.toUpperCase()}
                        </span>
                      ))}
                    </div>
                  </td>
                  <td>
                    <div style={{ width: 45, height: 45 }}>
                      <CircularProgressbar
                        value={calculateProgress(doc)}
                        text={`${calculateProgress(doc)}%`}
                        styles={buildStyles({
                          textSize: '28px',
                          pathColor: '#4a127e',
                          textColor: '#4a127e',
                          trailColor: '#f1f1f1'
                        })}
                      />
                    </div>
                  </td>
                  <td>
                    <div className="d-flex justify-content-center gap-2">
                      <Button className="btn-action be" onClick={() => handleAction('edit', doc.id)}><MdEdit /></Button>
                      <Button className="btn-action bp" onClick={() => handlecomplete(doc.id)}><MdSendAndArchive /></Button>
                      <Button className="btn-action br" onClick={() => handleAction('reject', doc.id, doc.application_no)}><MdBlockFlipped /></Button>
                    </div>
                  </td>
                </tr>
              )) : (
                <tr><td colSpan={9} className="text-center py-5 text-muted">No processing Nagal found</td></tr>
              )}
            </tbody>
          </Table>
        </div>

        <div className="pagination-footer d-flex flex-column flex-md-row justify-content-between align-items-center p-3 border-top bg-light gap-3">
            <div className="d-flex align-items-center gap-2">
                <span className="text-muted small">Rows per page:</span>
                <Form.Select 
                    size="sm" 
                    style={{ width: '80px', borderRadius: '6px' }}
                    value={rowsPerPage} 
                    onChange={(e) => { 
                        setRowsPerPage(Number(e.target.value)); 
                        setCurrentPage(1); 
                    }}
                >
                    {[5, 10, 20, 50].map(v => (
                        <option key={v} value={v}>{v}</option>
                    ))}
                </Form.Select>
            </div>

            <div className="text-muted small fw-medium">
                {processedData.length > 0 ? (
                    <>Showing <b>{indexOfFirstRow + 1}</b> to <b>{Math.min(indexOfLastRow, processedData.length)}</b> of <b>{processedData.length}</b> entries</>
                ) : "No entries found"}
            </div>

            <Pagination className="mb-0 custom-pagination shadow-sm">
                <Pagination.First disabled={currentPage === 1} onClick={() => setCurrentPage(1)} />
                <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>
                    <MdKeyboardArrowLeft size={20} />
                </Pagination.Prev>
                <Pagination.Item active className="px-2">{currentPage}</Pagination.Item>
                <Pagination.Next disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>
                    <MdKeyboardArrowRight size={20} />
                </Pagination.Next>
                <Pagination.Last disabled={currentPage === totalPages || totalPages === 0} onClick={() => setCurrentPage(totalPages)} />
            </Pagination>
        </div>
      </div>

      <AnimatePresence mode="wait">
        {docedit && (
          <motion.div key="edit-modal" initial={{ opacity: 0, scale: 0.9, y: 20 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.9, y: 20 }} className="modal-overlay-wrapper">
            <Editnl set_docedit={set_docedit} id={docid} showToast={showToast} onclose={fetchNl} />
          </motion.div>
        )}

        {reason && (
          <motion.div key="reason-modal" initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 30 }} className="modal-overlay-wrapper">
            <ReasonNl set_reason={set_reason} id={docid} appno={appno} showsToast={showsToast} showToast={showToast} onclose={fetchNl} TitleCase={(s) => s} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default HomeNl;